import React from 'react'

export default function Loader() {
  return (
    <div className='flex my-20 flex-col h-full w-full justify-center items-center'>
        <div className='w-10 h-10 rounded-full duration-150 animation'>

        </div>
        Loading
    </div>
  )
}
